import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { SavedFilterResponseDto } from '../dtos/saved-filter-response.dto';

@Injectable({ providedIn: 'root' })
export class SavedFiltersApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/cases/predefined-filters`;

  public getSavedFilters(): Observable<SavedFilterResponseDto[]> {
    return this._http.get<SavedFilterResponseDto[]>(this._baseUrl);
  }
}
